import { render } from "./ComputerProgramming.vue?vue&type=template&id=13e640a3&scoped=true"
import script from "./ComputerProgramming.vue?vue&type=script&lang=js"
export * from "./ComputerProgramming.vue?vue&type=script&lang=js"

import "./ComputerProgramming.vue?vue&type=style&index=0&id=13e640a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e640a3"]])

export default __exports__